import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { I18N_NAMESPACE, pl } from '@/assets/locales/pl.ts';

const resources = {
  en: pl,
} as const;

i18n.use(initReactI18next).init({
  defaultNS: I18N_NAMESPACE,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  lng: 'en',
  ns: [I18N_NAMESPACE],
  resources,
});
